import adminStatisticsListPage from '@/pages/admin-statistics/ListPage'

export default [
  {
    path: '/admin-statistics/list',
    name: 'AdminStatisticsList',
    component: adminStatisticsListPage,
  },
]
